import React from 'react';
import { compose, lifecycle, withHandlers } from 'recompose';
import * as PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from  'react-router-dom';
import { connect } from 'react-redux';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import CardStatus from '../CardStatus';
import { commonStyles } from '../../styles/styles';

import darkOverlay from '../../assets/darkOverlay.svg'

import {selectedProgram} from '../../redux/selectors'

import {
 resetUserPrograms,
 selectUserPrograms
} from '../../redux/reducers/userProgramsFull';

import {
  MDBCard,
  MDBCardTitle,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBAnimation
} from "mdbreact";
import { STORAGE_LINK } from '../../constants';


const ProgrammesCardReturn = ({ classes, rolloutCode, isSelected, status, name, description, startDate, dueDate, match, getProgram, returnFromProgramCard}) => (
  <div>
    {}
    {getProgram && <MDBCard
  className="card-image border border-white rounded-0 z-depth-3 d-none d-md-block"
  style={{
    padding:8,
    margin: '0 0px 5px'
  }}
>

  <div style={{position: 'relative'}}>
    <MDBBtn
        floating
        left
        tag='a'
        size='sm'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', left: -30, top:30}} 
        onClick={()=>returnFromProgramCard()}
      >
        <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
   

    <MDBAnimation reveal type="fadeIn">
      <img src={STORAGE_LINK+getProgram.background} className="z-depth-0"
                        style={{padding: 0, height: '100%', width: '100%'}} alt="" /></MDBAnimation>
    
      <div className="text-white align-items-center rgba-black-strong py-5 px-4" style={{position:'absolute', position: 'absolute', height: '100%', top: 0, width: '100%'}}>
      <div style={{position:'absolute', right:10, top:10}}>
      </div>
      <div style={{width:'100%'}}>
        <h6 tag="h5" className="pt-4 pb-3">
          <strong>{getProgram.name}</strong>
        </h6>
        <p>
          {getProgram.description}
        </p>
        <div style={{position: 'absolute',  top: 14, left: 15, fontSize: 12}}>
          {getProgram.rolloutCode}
        </div>
      </div>
    </div>
</div> </MDBCard> }

</div>
);

const styles = () => ({
  ...commonStyles,
  card: {
    borderRadius: 0,
    backgroundSize: 'cover',
    marginLeft: 0,
    marginBottom: 0,
    marginRight: 0,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 15,
    paddingBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    background: 'transparent',
    justifyContent: 'space-between',
    transition: '.2s height ease',
    fontFamily: 'Gotham-Black'
  },
  cardContent: {
    padding: 0,
    margin: 'auto',
    overflow: 'auto',
  },
  cardTitle: {
    color: '#FFF',
    fontSize: 18,
    lineHeight: '20px',
    marginTop: 19,
    marginBottom: 10,
    fontFamily: 'Gotham-Black'
  },
  programDescription: {
    color: '#FFF',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    marginTop: 10,
    marginBottom: 17,
  },
});

const mapStateToProps = state => ({
  
  getProgram: selectedProgram(state),
});

const mapDispatchToProps = dispatch => ({
  selectUserPrograms:(int) => dispatch(selectUserPrograms(int)),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
 
});

export default compose(withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withHandlers({
    returnFromProgramCard: props => ()=>{
     if(props.match.path=='/users/:programId'){
      props.resetUserPrograms();
      props.history.push('/team-leader'+ props.history.location.search)
     }
    }
  }),
  lifecycle({
    componentWillMount(){

      if(this.props.match.params.programId){
        
        this.props.selectUserPrograms(parseInt(this.props.match.params.programId))
      }
    }
  }),
  withStyles(styles))(ProgrammesCardReturn);

  ProgrammesCardReturn.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  status: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  startDate: PropTypes.string,
  dueDate: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/Components/Cards/ProgrammesCardReturn.jsx